import { FC } from 'react';
import { NavItem } from '@/types/nav-item';
import { NestedSidebarConfig } from '@/types/nested-sidebar-config';
import { cx } from '@/utils/cx';
import { DefaultSidebarLayout } from './layouts/default-layout';
import { NestedSidebarLayout } from './layouts/nested-layout';

export type SidebarProps = {
  title: string;
  subtitle?: string;
  navItems: NavItem[];
  darkVariant?: boolean;
  nestedConfig?: NestedSidebarConfig;
};

export const Sidebar: FC<SidebarProps> = ({
  title,
  subtitle,
  navItems,
  darkVariant,
  nestedConfig,
}) => (
  <aside
    className={cx(
      'h-full text-white',
      nestedConfig || darkVariant ? 'bg-secondaryShade' : 'bg-secondary',
    )}
  >
    {nestedConfig ? (
      <NestedSidebarLayout navItems={navItems} nestedConfig={nestedConfig} />
    ) : (
      <DefaultSidebarLayout
        darkVariant={darkVariant}
        navItems={navItems}
        subtitle={subtitle}
        title={title}
      />
    )}
  </aside>
);
